import { defineMessages } from "react-intl"

export const PRODUCT_INVENTORY_SECTION_MESSAGES = defineMessages({
    header: {
        id: "product.sections.inventory_section.header",
        defaultMessage: "Product inventory"
    },
    header_quantity_per_location: {
        id: "product.sections.inventory_section.header_quantity_per_location",
        defaultMessage: "Quantities per location"
    },
    header_adjustments: {
        id: "product.sections.inventory_section.header_adjustments",
        defaultMessage: "Adjustment history"
    },
    toggleText: {
        id: "product.sections.inventory_section.toggle_text",
        defaultMessage: "Track inventory"
    },
    toggleDescription: {
        id: "product.sections.inventory_section.toggle_description",
        defaultMessage: "Click the toggle to enable or disable inventory tracking for this product."
    },
    header_supplier_cost: {
        id: "product.sections.inventory_section.header_supplier_cost",
        defaultMessage: "Suppliers"
    },
    button_add_supplier_cost: {
        id: "product.sections.inventory_section.button_add_supplier_cost",
        defaultMessage: "Add supplier"
    }
})

export const PRODUCT_EXPORT_MESSAGES = defineMessages({
    header: {
        id: "product.catalog.export.header",
        defaultMessage: "Export All Results"
    },
    confirm_button: {
        id: "product.catalog.export.confirm_button",
        defaultMessage: "Export"
    },
    back_button: {
        id: "product.catalog.export.back_button",
        defaultMessage: "Cancel"
    },
    select_resource: {
        id: "product.catalog.export.select_resource",
        defaultMessage: "Select the resource you want to export"
    },
    product_details: {
        id: "product.catalog.export.product_details",
        defaultMessage: "Product details"
    },
    inventory_levels: {
        id: "product.catalog.export.inventory_levels",
        defaultMessage: "Export"
    },
    export_message: {
        id: "product.catalog.export.export_message",
        defaultMessage: "Your export will be sent to {email} as a CSV file and can take a few minutes to create."
    },
    selectAllSuppliersPlaceholder: {
        id: "product.catalog.export.select_all_suppliers_placeholder",
        defaultMessage: "Select All"
    }
})

export const PRODUCT_SUPPLIER_COST_LISTING_MESSAGES = defineMessages({
    header_supplier: {
        id: "product.components.product_supplier_cost_listing.supplier",
        defaultMessage: "Supplier"
    },
    header_cost: {
        id: "product.components.product_supplier_cost_listing.cost",
        defaultMessage: "Unit Cost"
    },
    use_as_default_button_label: {
        id: "product.components.add_product_supplier_modal.use_as_default_button_label",
        defaultMessage: "Use as default"
    },
    default_supplier_cost_badge_label: {
        id: "product.components.add_product_supplier_modal.default_supplier_cost_badge_label",
        defaultMessage: "Default"
    },
    empty_listing_message: {
        id: "product.components.product_supplier_cost_listing.empty_listing_message",
        defaultMessage: "You don’t have any suppliers for that item. Click on the 'Add Supplier' button to add one."
    }
})
export const ADD_PRODUCT_SUPPLIER_MODAL_MESSAGES = defineMessages({
    header: {
        id: "product.components.add_product_supplier_modal.header",
        defaultMessage: "Add supplier"
    },
    label_supplier_name: {
        id: "product.components.add_product_supplier_modal.label_supplier",
        defaultMessage: "Supplier Name"
    },
})


// WEBPACK FOOTER //
// ./src/utils/product/messages.ts